// extracted by mini-css-extract-plugin
export var activityContainer = "_i3-0";
export var typingIndicatorContainer = "_i3-1";
export var typingIndicatorDot = "_i3-2";
export var wave = "_i3-3";